/*
 * @Descripttion: 画布人群分析节点不可超过10的拦截弹窗
 * @Author: yang chenglin
 */
import React from 'react';
import InfoDialog from '@/components/Dialog/InfoDialog'

function CrowdEffectNumDialog({ flag, cancelHandel}) {
  return (
    <InfoDialog flag={flag} title='提示' promptInfo='添加节点失败！最多只能添加10个人群包分析节点哦！' cancelHandel={cancelHandel}/>
  );
}

export default CrowdEffectNumDialog;
